// @flow

import React, { Fragment } from 'react';
import NavLink from 'hoc/portalPath/NavLink';
import type { Person, L10n, RouteStage } from 'type/type';
import ShowAt from 'react-aaui/lib/viewport/ShowAt';
import HideAt from 'react-aaui/lib/viewport/HideAt';
import { parse, stringify } from 'query-string';

import LivingResultList from './LivingResultList';
import StagedResult from '../ResultItem/StagedResult';
import { formatUserInfo } from '../ResultItem/ResultItem';

type resultType = {
  id: string,
  bib: string,
  person: Person,
  rank: number,
  previousRank: number,
  splitResults: [],
  participantNumber: string,
}

type propsType = {
  index: number,
  item: resultType,
  l10n: L10n,
  stages: [ RouteStage ],
  isKioskMode: boolean,
  queryString: string
}

const viewports = {
  lgAndAbove: { minWidth: '1280px' },
};

const LeaderBoardItem = (props: propsType) => {
  const {
    item,
    index,
    stages,
    l10n,
    isKioskMode,
    queryString,
  } = props;
  const {
    firstName, lastName, gender, age,
  } = item.person;

  const queryParams = {
    pn: item.participantNumber,
    ...(isKioskMode ? parse(queryString) : {}),
  };

  const personName = (
    <NavLink to={`/participants/${item.id}?${stringify(queryParams)}`}>
      {`${firstName} ${lastName}`}
    </NavLink>
  );

  return (
    <div className="event-home__item">
      <ShowAt viewports={viewports} smAndAbove>
        <Fragment>
          <div className="event-home__rank">{index + 1}</div>
          <StagedResult
            containerClassName="event-home__bib"
            result={item.bib || l10n.formatMessage('page.event.NA')}
            info={l10n.formatMessage('global.participant.bib')} />
          <StagedResult
            containerClassName="event-home__person"
            result={personName}
            info={formatUserInfo(gender, age, l10n)} />
        </Fragment>
      </ShowAt>
      <ShowAt viewports={viewports} lgAndAbove>
        <LivingResultList
          splitResults={item.splitResults}
          itemLimit={6}
          stages={stages} />
      </ShowAt>
      <ShowAt viewports={viewports} smAndAbove>
        <HideAt viewports={viewports} lgAndAbove>
          <LivingResultList
            splitResults={item.splitResults}
            itemLimit={2}
            stages={stages} />
        </HideAt>
      </ShowAt>
      <HideAt viewports={viewports} smAndAbove>
        <div className="event-home__userInfo">
          <div className="event-home__rank">{index + 1}</div>
          <StagedResult
            containerClassName="event-home__person"
            result={personName}
            info={`Bib # ${item.bib} | ${formatUserInfo(gender, age, l10n)}`} />
        </div>
        <LivingResultList
          splitResults={item.splitResults}
          itemLimit={1}
          stages={stages} />
      </HideAt>
    </div>
  );
};

export default LeaderBoardItem;
